import React, { useEffect } from 'react';
import { View } from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import { Spinner } from '@ui-kitten/components';

import { fetchAuthSession } from 'aws-amplify/auth';
import { RootStackScreenProps } from 'src/core/types/RootNavigationParamList';
import { BackendApi } from 'src/api/shared';
import { useAppStore } from 'src/core/store';

const TenantDataSharingScreen = ({ navigation, route }: RootStackScreenProps<'SharingApprove'>) => {
  const setDataSharing = useAppStore((state) => state.setDataSharing);
  const setDataSharingModal = useAppStore((state) => state.setDataSharingModal);
  const setPendingDataSharing = useAppStore((state) => state.setPendingDataSharing);
  const isFocused = useIsFocused();
  const { t, u } = route.params as any;

  useEffect(() => {
    const checkSessionAndFetchStatus = async () => {
      try {
        await fetchAuthSession();
        setPendingDataSharing('');
        const response = await BackendApi.post('/tenants/check-user-sharing-request-status', {
          proUserId: u,
          tenantKey: t
        });

        setDataSharing(true);
        setDataSharingModal({
          ...response.data,
          proUserId: u,
          tenantKey: t
        });

        navigation.navigate('Home');
      } catch (error) {
        console.error(error);
        setPendingDataSharing(route.path ? route.path : '');
      }
    };

    if (isFocused) {
      checkSessionAndFetchStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Spinner />
    </View>
  );
};

export default TenantDataSharingScreen;
